var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgView = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#202223",
  fillRule: "evenodd",
  d: "M15.97 7.78C15.95 7.718 14.133 1.6 8 1.6S.05 7.718.03 7.78a.8.8 0 0 0 0 .44C.05 8.28 1.868 14.4 8 14.4s7.951-6.119 7.97-6.18a.8.8 0 0 0 0-.44M8 12.8c-4.374 0-6.01-3.818-6.358-4.8C1.99 7.016 3.627 3.2 8 3.2c4.375 0 6.011 3.82 6.358 4.8-.348.982-1.984 4.8-6.358 4.8m0-3.2c-.883 0-1.6-.718-1.6-1.6S7.117 6.4 8 6.4c.882 0 1.6.717 1.6 1.6 0 .882-.718 1.6-1.6 1.6m0-4.8A3.203 3.203 0 0 0 4.8 8c0 1.765 1.435 3.2 3.2 3.2s3.2-1.435 3.2-3.2S9.766 4.8 8 4.8",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "view_svg__a",
  width: 16,
  height: 14,
  x: 0,
  y: 1,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M15.97 7.78C15.95 7.718 14.133 1.6 8 1.6S.05 7.718.03 7.78a.8.8 0 0 0 0 .44C.05 8.28 1.868 14.4 8 14.4s7.951-6.119 7.97-6.18a.8.8 0 0 0 0-.44M8 12.8c-4.374 0-6.01-3.818-6.358-4.8C1.99 7.016 3.627 3.2 8 3.2c4.375 0 6.011 3.82 6.358 4.8-.348.982-1.984 4.8-6.358 4.8m0-3.2c-.883 0-1.6-.718-1.6-1.6S7.117 6.4 8 6.4c.882 0 1.6.717 1.6 1.6 0 .882-.718 1.6-1.6 1.6m0-4.8A3.203 3.203 0 0 0 4.8 8c0 1.765 1.435 3.2 3.2 3.2s3.2-1.435 3.2-3.2S9.766 4.8 8 4.8",
  clipRule: "evenodd"
}))));
export default SvgView;